const flowTypeLabel = "_35sfvyvc5d";
const sep = "_35sslgm2v8";
const dialog = "_35sd1veibl1";
const datalist = "_35sd1t1npzs";

export { datalist, dialog, flowTypeLabel, sep };
import "./_flow-type-context.style.linaria.module.css";
//# sourceMappingURL=_flow-type-context.style.js.map
